export const iconFontAwesomeUsersPeoplePersonCircleQuestion = (
	<i className="fa-solid fa-person-circle-question"></i>
);
